module.exports = __webpack_public_path__ + "media/components/maps/incidents/pins/Violent Conflict-626866a4029c1fc51e1d953a225e61b3.png";